import { Button, Form, FormProps, Input, Popconfirm, Select } from "antd";
import React, { Dispatch, useEffect, useState } from "react";
import { FieldType, IZipAndLocalName } from "../../types";
import { useDispatch, useSelector } from "react-redux";
import { AppStateType } from "../../store";
import {
  addDomains,
  createSitesFromCategory,
  DomainThunkType,
  removeAllDomains,
  removeDomain,
  updDomain,
} from "../../store/actions/domainActions";
import { AnyAction } from "redux";

interface IProps {
  activeCategory: string;
}

export const DomainListTextArea = ({ activeCategory }: IProps) => {
  const [editedDomain, setEditedDomain] = useState("");
  const [zipsAndLocalNames, setZipsAndLocalNames] = useState<
    IZipAndLocalName[]
  >([]);
  const dispatch = useDispatch() as Dispatch<DomainThunkType | AnyAction>;
  const [form] = Form.useForm();
  const [form2] = Form.useForm();
  const isDomainsLoadingInProgress = useSelector(
    (state: AppStateType) => state.domain.isDomainsLoadingInProgress
  );
  const isDomainsCreatingInProgress = useSelector(
    (state: AppStateType) => state.domain.isDomainsCreatingInProgress
  );
  const isDomainsUpdatingInProgress = useSelector(
    (state: AppStateType) => state.domain.isDomainsUpdatingInProgress
  );
  const isCreatingSitesFromCategoryInProgress = useSelector(
    (state: AppStateType) => state.domain.isCreatingSitesFromCategoryInProgress
  );
  const categories = useSelector(
    (state: AppStateType) => state.categories.categories
  );
  const domains = useSelector((state: AppStateType) => state.domain.domains);
  const onFinish: FormProps<FieldType>["onFinish"] = (values) => {
    console.log("Success:", values.domains.split("\n"));
    const domains = values.domains.split("\n").map((d) => d.trim());

    dispatch(addDomains(domains, activeCategory));

    // dispatch(createAppliance({ ...values, category: activeCategory }));
    form.setFieldValue("domains", "");
  };

  const onFinish2: FormProps<FieldType>["onFinish"] = (values) => {
    console.log("Success:", values);
    dispatch(
      updDomain(
        {
          domain: values.domain,
          category: values.category,
          zip: values.zip || "",
          companyName: values.companyName || "",
          isDisabled: values.isDisabled,
        },
        editedDomain,
        activeCategory,
        setEditedDomain
      )
    );
  };

  useEffect(() => {
    if (editedDomain) {
      form2.setFieldValue(
        "domain",
        domains.find((d) => d._id === editedDomain)?.domain
      );
      form2.setFieldValue(
        "zip",
        domains.find((d) => d._id === editedDomain)?.zip
      );
      form2.setFieldValue(
        "category",
        domains.find((d) => d._id === editedDomain)?.category
      );
      form2.setFieldValue(
        "companyName",
        domains.find((d) => d._id === editedDomain)?.companyName
      );
      form2.setFieldValue(
        "isDisabled",
        domains.find((d) => d._id === editedDomain)?.isDisabled
      );
    }
  }, [editedDomain]);

  useEffect(() => {
    let zipsAndNames: IZipAndLocalName[] = [];
    const filteredDomains = [...domains].filter(
      (d) => !d.isDisabled && d.zip && d.companyName
    );
    filteredDomains.forEach((fd) =>
      zipsAndNames.push({ zip: fd.zip, localName: fd.companyName })
    );

    setZipsAndLocalNames(zipsAndNames);
  }, [domains]);

  const createSites = () => {
    dispatch(createSitesFromCategory(zipsAndLocalNames, activeCategory));
  };

  return (
    <>
      <h3>Add domains</h3>
      <Form
        style={{ display: "flex", flexDirection: "column" }}
        onFinish={onFinish}
        form={form}
      >
        <Form.Item<FieldType> name="domains">
          <Input.TextArea
            placeholder="Domains list"
            style={{ width: "100%" }}
            size="middle"
          />
        </Form.Item>
        <Button
          htmlType="submit"
          loading={isDomainsCreatingInProgress}
          type="primary"
          size="middle"
          disabled={false}
        >
          Add
        </Button>
      </Form>
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent:
            zipsAndLocalNames.length > 0 || domains.length > 0
              ? "space-between"
              : "flex-start",
          alignItems: "center",
        }}
      >
        <h3>Domains</h3>{" "}
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: 16,
          }}
        >
          {zipsAndLocalNames.length > 0 && (
            <Popconfirm
              disabled={isCreatingSitesFromCategoryInProgress}
              title={"Confirmm action please"}
              description={`Create sites?`}
              onConfirm={createSites}
            >
              <p style={{ textDecoration: "underline", cursor: "pointer" }}>
                {!isCreatingSitesFromCategoryInProgress
                  ? `Create ${zipsAndLocalNames.length} sites`
                  : "Loading..."}
              </p>
            </Popconfirm>
          )}
          {domains.length > 0 && (
            <Popconfirm
              disabled={isDomainsUpdatingInProgress}
              title={"Confirmm action please"}
              description={`Remove all ${domains.length} domains?`}
              onConfirm={() => dispatch(removeAllDomains(activeCategory))}
            >
              <p
                style={{
                  textDecoration: "underline",
                  cursor: "pointer",
                  color: "red",
                }}
              >
                {!isDomainsUpdatingInProgress ? "Remove all" : "Loading..."}
              </p>
            </Popconfirm>
          )}
        </div>
      </div>
      {isDomainsLoadingInProgress && <div>Loading domains...</div>}
      {domains.length === 0 && <div>no domains</div>}
      {[...domains]
        .sort((a, b) => {
          if (a.isDisabled === b.isDisabled) {
            return 0;
          }
          return a.isDisabled ? 1 : -1;
        })
        .map((d) => (
          <>
            {editedDomain !== d._id ? (
              <div
                style={{
                  opacity: d.isDisabled ? 0.5 : 1,
                  textDecoration: d.isDisabled ? "line-through" : "none",
                }}
              >
                <div>
                  {d.domain} {d.zip ? `/ ${d.zip}` : ""}{" "}
                  <span
                    style={{
                      cursor: "pointer",
                      color: "blue",
                      textDecoration: "underline",
                    }}
                    onClick={() => (d._id ? setEditedDomain(d._id) : null)}
                  >
                    Edit
                  </span>{" "}
                  <Popconfirm
                    disabled={isDomainsUpdatingInProgress}
                    title={"Confirmm action please"}
                    description={`Remove ${d.domain}?`}
                    onConfirm={() =>
                      d._id
                        ? dispatch(removeDomain(d._id, activeCategory))
                        : null
                    }
                  >
                    <span
                      style={{
                        cursor: "pointer",
                        color: "red",
                        textDecoration: "underline",
                      }}
                    >
                      Remove
                    </span>
                  </Popconfirm>
                </div>
                <div>{d.companyName}</div>
              </div>
            ) : (
              <Form
                onFinish={onFinish2}
                form={form2}
                style={{ display: "flex", flexDirection: "column" }}
              >
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <Form.Item<FieldType> name="domain">
                    <Input
                      placeholder="domain"
                      style={{ width: 200 }}
                      size="middle"
                    />
                  </Form.Item>
                  <Form.Item<FieldType> name="zip">
                    <Input
                      placeholder="zip"
                      style={{ width: 100 }}
                      size="middle"
                    />
                  </Form.Item>
                </div>

                <Form.Item<FieldType> name="category">
                  <Select
                    placeholder="Select category"
                    optionFilterProp="children"
                    options={categories.map((c) => ({
                      value: c._id,
                      label: c.name,
                    }))}
                  />
                </Form.Item>
                <Form.Item<FieldType> name="companyName">
                  <Input
                    placeholder="Company name"
                    style={{ width: 300 }}
                    size="middle"
                  />
                </Form.Item>
                <Form.Item<FieldType> name="isDisabled" label="Is active">
                  <Select
                    placeholder="select"
                    optionFilterProp="children"
                    options={[
                      {
                        label: "disabled",
                        value: true,
                      },
                      {
                        label: "active",
                        value: false,
                      },
                    ]}
                  />
                </Form.Item>
                <Button
                  //style={{ marginLeft: 10 }}
                  htmlType="submit"
                  loading={isDomainsUpdatingInProgress}
                  type="primary"
                  size="middle"
                  disabled={isDomainsUpdatingInProgress}
                >
                  Save
                </Button>
                <Button
                  //style={{ marginLeft: 10 }}
                  onClick={() => setEditedDomain("")}
                  disabled={isDomainsUpdatingInProgress}
                  type="link"
                  size="middle"
                >
                  Cancel
                </Button>
              </Form>
            )}
            ----------------
          </>
        ))}
    </>
  );
};
